(function() {
    'use strict';
    var RequestPayDetailVerificationCtrl = function($scope, $compile,ajaxCall, xmsNotificationFactory, $uibModalInstance) {
        console.log("Inside RequestPayDetailVerificationCtrl");
        $scope.ngModel = {};
        console.log("$scope.payDetailVerfModel"+$scope.ngModel);

        $scope.fnRequestPayDetailsVerification = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/candidate/requestPaymentDetailVerification?";
            var data    = $scope.ngModel;

            console.log("data .."+data)

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    console.log("Msg Type=" + result.data.responseType);
                    xmsNotificationFactory.addObj({id: "reqPayDetailsVerification", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:5});
                    $uibModalInstance.dismiss();
                },
                function(result) {
                    console.log("failure ");
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "reqPayDetailsVerification", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.dismiss();

                }
            );
            $event.preventDefault();
        }

        $scope.cancel = function(e) {
            $uibModalInstance.dismiss('cancel');
        }

    }
    RequestPayDetailVerificationCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance'];
    angular.module('app').controller('RequestPayDetailVerificationCtrl', RequestPayDetailVerificationCtrl);
}());
